// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2TIb7","title":"BackImages_title__3wdEc","images":"BackImages_images__1uMfZ"};